var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuoteCtrl = function () {
    _createClass(QuoteCtrl, null, [{
        key: '$inject',
        get: function get() {
            return ['StateUtils', 'ViewModelService', '$q', 'ModalService', '$state', 'paymentType', 'UserInfoService'];
        }
    }]);

    function QuoteCtrl(StateUtils, ViewModelService, $q, ModalService, $state, paymentType, UserInfoService) {
        _classCallCheck(this, QuoteCtrl);

        this.ModalService = ModalService;
        this.$q = $q;
        this.$state = $state;
        this.paymentType = paymentType;
        this.next = this.next.bind(this);
        this.cancel = this.cancel.bind(this);
        this.StateUtils = StateUtils;
        this.UserInfoService = UserInfoService;
    }

    _createClass(QuoteCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            this.model = this.StateUtils.activeDataForState(true).model;
            this.flowModel = this.StateUtils.activeDataForState(true).flowModel;
            var quoteData = this.model.value.quoteData.offeredQuotes[0].premium;

            this.effectiveDate = this.model.value.baseData.effectiveDate;
            this.startDate = this.model.value.baseData.periodStartDate;
            this.endDate = this.model.value.baseData.periodEndDate;
            this.newPremium = quoteData.total;
            this.paymentPlans = this.model.value.bindData.paymentPlans;
            this.policyNumber = this.model.value.policyNumber;
            this.multiplePaymentPlans = this.paymentPlans.length !== 1;
            this.paymentPlanDescription = this.getPaymentPlanDescription();
            this.isAgent = this.UserInfoService.isAgent();
            this.jobType = this.model.value.baseData.jobType;
            this.productName = this.model.value.baseData.productName;
        }
    }, {
        key: 'getPaymentPlanDescription',
        value: function getPaymentPlanDescription() {
            var _this = this;

            if (!this.model.bindData.selectedPaymentPlan) {
                return undefined;
            }
            var paymentPlan = this.paymentPlans.find(function (p) {
                return p.billingId === _this.model.bindData.selectedPaymentPlan.value;
            });
            return paymentPlan ? paymentPlan.name : undefined;
        }
    }, {
        key: 'editPaymentPlans',
        value: function editPaymentPlans() {
            this.editingPaymentPlans = true;
        }
    }, {
        key: 'isWire',
        value: function isWire() {
            return this.model.bindData.paymentDetails.paymentMethod.value === this.paymentType.WIRE;
        }
    }, {
        key: 'isCreditCard',
        value: function isCreditCard() {
            return this.model.bindData.paymentDetails.paymentMethod.value === this.paymentType.CREDIT_CARD;
        }
    }, {
        key: 'updatePaymentDetails',
        value: function updatePaymentDetails() {
            switch (this.model.value.bindData.paymentDetails.paymentMethod) {
                case this.paymentType.WIRE:
                    delete this.model.value.bindData.paymentDetails.creditCardData;
                    break;
                case this.paymentType.CREDIT_CARD:
                    delete this.model.value.bindData.paymentDetails.bankAccountData;
                    break;
                case this.paymentType.REDISTRIBUTE:
                    delete this.model.value.bindData.paymentDetails.creditCardData;
                    delete this.model.value.bindData.paymentDetails.bankAccountData;
                    break;
                default:
                    delete this.model.value.bindData.paymentDetails.creditCardData;
                    delete this.model.value.bindData.paymentDetails.bankAccountData;
            }
        }
    }, {
        key: 'next',
        value: function next(nextFn, form) {
            if (!this.model.bindData.selectedPaymentPlan.value) {
                this.ModalService.showError('quoteandbind.controllers.PaymentDetailsCtrl.Please choose a payment plan', 'quoteandbind.controllers.PaymentDetailsCtrl.You have not chosen a payment plan');

                return nextFn();
            }
            if (form.invalid) {
                return nextFn();
            }
            this.updatePaymentDetails();
            nextFn(this.model);
        }
    }, {
        key: 'openReferToUnderwriterForm',
        value: function openReferToUnderwriterForm(form) {
            form.submitted = true;
            if (form.invalid) {
                return;
            }
            this.referingToUnderwriter = true;
        }
    }, {
        key: 'closeReferToUnderwriterForm',
        value: function closeReferToUnderwriterForm() {
            this.note = '';
            this.referingToUnderwriter = false;
        }
    }, {
        key: 'referToUnderwriter',
        value: function referToUnderwriter() {
            this.updatePaymentDetails();
            var note = { value: this.note };
            this.flowModel.next(this.model, [note]);
        }
    }, {
        key: 'cancel',
        value: function cancel(cancelFn) {
            var modelEdited = angular.copy(this.model.value);
            delete modelEdited.bindData.paymentDetails;
            cancelFn(this.model, { modelEdited: modelEdited });
        }
    }]);

    return QuoteCtrl;
}();

export default QuoteCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-common-angular/components/paymentWithPaymentPlan/paymentCtrl.js
// module id = 1008
// module chunks = 0